const productsCodesTour = {
  id: 'products-codes',
  title: 'Products and codes',
  summary: 'Code your items and pick products from the catalogue.',
  // Only an open schedule sheet has these targets; the list page has none.
  match: '/dashboard/yawn/schedule/,!/dashboard/yawn/schedule/list,!/dashboard/yawn/schedule/new',
  autoStart: false,
  version: 1,
  steps: [
    {
      target: 'sheet-catalogue-view-toggle',
      title: 'List or grid',
      body: 'Switch between a compact list and a visual grid while you browse the catalogue.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-catalogue-preview',
      title: 'Preview before you commit',
      body: 'See the full description, image, manufacturer notes and contacts, and open certification links.',
      tip: 'Star a product to keep it handy for future projects.',
      placement: 'left',
      optional: true,
    },
    {
      target: 'sheet-description-edit',
      title: 'Tailor the description',
      body: 'Edit the text freely. Apply headings, bold and italics, insert your contract predefined terms, or Tab to indent a clause.',
      tip: 'Asterisks (***) mark the variables you still need to confirm.',
      placement: 'left',
      optional: true,
    },
    {
      target: 'sheet-request-product',
      title: 'Missing a product?',
      body: 'Request it. Fill in what you know and our research team will verify it and add it to the catalogue.',
      placement: 'bottom',
      optional: true,
    },
  ],
};

export default productsCodesTour;
